import { Component, EventEmitter, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ListPlansComponent } from './list-plans/list-plans.component';
import { CreatePlanComponent } from './create-plan/create-plan.component';
@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.css'],
    imports: [CommonModule, ListPlansComponent, CreatePlanComponent]
})
export class PlansComponent {

  @Output()
  showUpdatePlan: EventEmitter<number> = new EventEmitter<number>();

  id_plan: any;

  showListPlans: boolean = true;

  showForm(show: boolean) {
    this.showListPlans = !show;
  }

  updatePlan(idPlan: any) {
    if (idPlan) {
      this.id_plan = idPlan;
    }
  }
}
